import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import DataTable from "components/common/DataTable";
import "datatables.net";
import DataTableApiResponse from "interfaces/DataTableApiResponse";
import ProductSummary from "interfaces/ProductSummary";
import * as $ from "jquery";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import getBaseUrl from "utils/getBaseUrl";
import ContentLoading from "components/common/ContentLoading";

interface State {
    data: ProductSummary[];
    spinner: boolean;
    errorMessage?: string;
}

export default class Index extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    private baseUrl: string;
    private mainDataTableRef: React.RefObject<DataTable>;
    private dataTableRef: React.RefObject<HTMLTableElement>;

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            data: [],
            spinner: true,
            errorMessage: undefined,
        };

        this.baseUrl = getBaseUrl();
        this.mainDataTableRef = React.createRef();
        this.dataTableRef = React.createRef();

        this.dataTableData = this.dataTableData.bind(this);
        this.dataTableDataFilter = this.dataTableDataFilter.bind(this);
        this.handleDataTableDraw = this.handleDataTableDraw.bind(this);
        this.deleteProduct = this.deleteProduct.bind(this);
    }

    public render() {
        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Items</BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}

                    <div className="card card--datatables">
                        <div className="card-block">
                            <h2 className="card__title">Items</h2>
                            <div className="datatable-wrapper">
                                <DataTable
                                    ajaxUrl={this.baseUrl + "api/products/summary"}
                                    useAuth={true}
                                    ajaxData={this.dataTableData}
                                    ajaxDataFilter={this.dataTableDataFilter}
                                    onDraw={this.handleDataTableDraw}
                                    ref={this.mainDataTableRef}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: "12%" }}>ID</th>
                                            <th style={{ width: "12%" }}>Code</th>
                                            <th style={{ width: "10%" }}>Number</th>
                                            <th style={{ width: "26%" }}>Item Name</th>
                                            <th style={{ width: "10%" }}>UM</th>
                                            <th style={{ width: "22%" }}>Category</th>
                                            {/*{BQS && <th style={{ width: "8%" }}>Is Kit</th>}*/}
                                        </tr>
                                    </thead>
                                    <tbody></tbody>
                                </DataTable>
                                {this.state.spinner ? (
                                    <ContentLoading />
                                ) : (
                                    <table className="d-none" ref={this.dataTableRef}>
                                        <tbody>
                                            {this.state.data.map((item, index) => (
                                                <tr key={item.id}
                                                    id={`row-${item.id}`}
                                                >
                                                    <td>{item.id}</td>
                                                    <td>
                                                        {item.mincronId}
                                                    </td>
                                                    <td>{item.number}</td>
                                                    <td>
                                                        {item.name}
                                                    </td>
                                                    <td>{item.unitMeasurement}</td>
                                                    <td>{item.sectionName}</td>
                                                    {/*{BQS && <td>*/}
                                                    {/*    {item.blocked === true ? "Yes" : "No"}*/}
                                                    {/*</td>*/}
                                                    {/*}*/}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount() {
        document.title = "Items - " + SITE_NAME;
    }

    private dataTableData(data: any) {
        let sortFields = [
            "id",
            "mincronId",
            "sectionName",
            "unitMeasurement",
            "number",
            "name",
            //"isKit",
        ];

        let newData = {
            pageNumber: Math.floor(data.start / data.length) + 1,
            pageSize: data.length,
            sortField: sortFields[data.order[0].column],
            sortDirection: data.order[0].dir === "asc" ? 1 : 2,
            search: data.search.value,
            draw: data.draw,
        };

        return newData;
    }

    private dataTableDataFilter(data: string) {
        var json = JSON.parse(data) as DataTableApiResponse<ProductSummary>;

        this.setState({
            data: json.items,
            spinner: false,
        });

        let tableData = [];
        let $tr = $(this.dataTableRef.current!).find("tr");
        for (let i = 0; i < $tr.length; i++) {
            let $td = $tr.eq(i).find("td");
            let rowData = [];
            for (let j = 0; j < $td.length; j++) {
                rowData.push($td.eq(j).clone(true, true).html());
            }
            tableData.push(rowData);
        }

        let newData = {
            draw: json.draw,
            recordTotal: json.metadata.totalItemCount,
            recordsFiltered: json.metadata.totalItemCount,
            data: tableData,
        };

        return JSON.stringify(newData);
    }

    //private handleDataTableDraw(dataTable: any) {
    //    $(dataTable)
    //        .find("a:not([href='#'])")
    //        .click((e) => {
    //            e.preventDefault();
    //            this.props.history.push($(e.currentTarget).attr("href")!);
    //        });
    //    $(dataTable)
    //        .find(".btn-delete")
    //        .click((e) => {
    //            e.preventDefault();
    //            this.deleteProduct(parseInt($(e.currentTarget).attr("data-id")!, 10));
    //        });
    //}

    private handleDataTableDraw(dataTable: any) {
        $(dataTable).off("click", "tr");
        $(dataTable).find("a:not([href='#'])").off("click");
        $(dataTable)
            .find("tbody tr")
            .css("cursor", "pointer");

        $(dataTable)
            .find("a:not([href='#'])")
            .on("click", (e) => {
                e.preventDefault();
                this.props.history.push($(e.currentTarget).attr("href")!);
            });

        $(dataTable).on("click", "tr", (e) => {
            const rowId = $(e.currentTarget).find("td").first().text().trim();
            if (rowId) {
                this.props.history.push(`/products/${rowId}`);
            }
        });
    }

    private async deleteProduct(id: number) {
        this.setState({ errorMessage: undefined });
        let response = await apifetch(
            `products/${id}`,
            {
                method: "DELETE",
            },
            true
        );
        if (response.ok) {
            this.mainDataTableRef.current!.reload();
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/products/Index.tsx